// extracted by mini-css-extract-plugin
module.exports = {"backButton__wrapper":"backButton__wrapper-339zR","toolbar__backButton":"toolbar__backButton-zX-jj"};